function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99996 6.83333V11.8333M6.99996 11.8333L4.49996 9.33333M6.99996 11.8333L9.49996 9.33333M11.1666 16H2.83329C1.91282 16 1.16663 15.2538 1.16663 14.3333V2.66667C1.16663 1.74619 1.91282 1 2.83329 1H7.48812C7.70913 1 7.92109 1.0878 8.07737 1.24408L12.5892 5.75592C12.7455 5.9122 12.8333 6.12416 12.8333 6.34518V14.3333C12.8333 15.2538 12.0871 16 11.1666 16Z",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 17,
    viewBox: "0 0 14 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.0b125c64.svg";
export { ForwardRef as ReactComponent };